import { parseOnlyNumericValue, safeToString, sliceText } from "../../../utils/common";

export const STATUTORY_KYC_CONST = {
  esic_insurance_number: {
      fullWidth: true,
      required: true,
      label: "Insurance No",
      placeholder: "Type Here...",
      type: "number",
      name: "esic_insurance_number",
      customOptions: {
        formatValueFn:(value)=>{   
          return sliceText(parseOnlyNumericValue(safeToString(value)),10);
       }
        
        }
      
    },
  
    esic_registration_date: {
      fullWidth: true,
      required: true,
      label: "Registration Date",
      placeholder: "Type Here...",
      type: "date",
      name: "esic_registration_date",
      valueSinc: true
    },
  
    esic_card_attachment: {
      fullWidth: true,
      label: "Attachment",
      placeholder: "Type Here...",
      type: "file",
      name: "esic_card_attachment",
      valueSinc: true
    },
  
    member_payroll: {
      fullWidth: true,
      label: "Member Payroll",
      options: [
        { id: false, name: "No" },
        { id: true, name: "Yes" }
      ],
      placeholder: "Select Here...",
      type: "text",
      name: "member_payroll"
    },
  
    epf_id_ac_no: {
      fullWidth: true,
      label: "EPF Id Ac No",
      placeholder: "Type Here...",
      type: "text",
      name: "epf_id_ac_no"
    },
  
    uan_no: {
      fullWidth: true,
      required: true,
      label: "UAN",
      placeholder: "Type Here...",
      type: "text",
      name: "uan_no",
      customOptions:{
        formatValueFn:(value)=>{   
          value = sliceText(parseOnlyNumericValue(safeToString(value)),12);
         return value;
       }
        }
    },
  
    ppo_no: {
      fullWidth: true,
      label: "PPO No",
      placeholder: "Type Here...",
      type: "text",
      name: "ppo_no",
      customOptions:{
        formatValueFn:(value)=>{   
          value = sliceText(parseOnlyNumericValue(safeToString(value)),12);
         return value;
       }
        
        }
    },
  
    employee_contribution: {
      fullWidth: true,
      required: true,
      label: "Employee Contribution",
      options: [
        {
          id: "restrict_contribution",
          name: "Restrict Contribution to ₹1500 of PF Wages"
        },
        {
          id: "unrestricted_contribution",
          name: "Unrestricted Contribution (Based on Actual Wages)"
        }
      ],
      placeholder: "Select Here...",
      name: "employee_contribution"
    },
  
    retired_govt_employee: {
      fullWidth: true,
      required: true,
      label: "Retired Govt Employee",
      options: [
        { id: true, name: "Yes" },
        { id: false, name: "No" }
      ],
      placeholder: "Select Here...",
      name: "retired_govt_employee"
    },
    epf_registration_date:{
        fullWidth:true,
        label:"Registration Date",
        placeholder:"Type Here...",
        type:"date",
        valueSinc:true,
        name:"epf_registration_date"
    },
    epf_uan_attachment: {
        fullWidth: true,
        label: "Attachment",
        placeholder: "Type Here...",
        type: "file",
        name: "epf_uan_attachment",
        valueSinc: true
      },
    bank_name: {
      fullWidth: true,
      // required: true,
      label: "Bank Name",
      placeholder: "Type Here...",
      type: "text",
      name: "bank_name"
    },
  
    branch_name: {
      fullWidth: true,
      // required: true,
      label: "Branch Name",
      placeholder: "Type Here...",
      type: "text",
      name: "branch_name"
    },
  
    account_number: {
      fullWidth: true,
      // required: true,
      label: "Account Number",
      placeholder: "Type Here...",
      type: "number",
      name: "account_number",
      customOptions: {
        formatValueFn:(value)=>{   
          value = sliceText(parseOnlyNumericValue(safeToString(value)),18);
         return value;
       }
        }
    },
  
    ifsc_code: {
      fullWidth: true,
      // required: true,
      label: "IFSC Code",
      placeholder: "Type Here...",
      type: "text",
      name: "ifsc_code",
      customOptions:{
        formatValueFn:(value)=>{   
          
          value = sliceText((safeToString(value)),11);
         return value;
       }
        
        }
    },
    payment_through: {
      name: "payment_through",
      label: "Payment Through",
      type: "text",
      // inputType: "se",
      // component: "InputField",
      fullWidth: true,
      placeholder: "Type Here...",
      required: false,
      options: [
        { id: "NEFT", name: "NEFT" },
        { id: "IMPS", name: "IMPS" }
      ],
    },
    document_type:{
      fullWidth:true,
      label:"Document Type",
      placeholder:"Select Here...",
      name:"document_type"
    },
    document_number:{type:"text",
    fullWidth:true,
    label:"Number/Code",
    placeholder:"Type Here...",
    name:"document_number"
  }

  };
  